/**
 * Display names for the project `model` property's options (content-intelligence
 * model keys; the list itself comes from the project service, see backend
 * app/services/models.py). Same labels as FRaiME.
 */
export const MODEL_LABELS: Record<string, string> = {
  "opus-5": "Claude Opus 5",
  "sonnet-5": "Claude Sonnet 5",
  "opus-48": "Claude Opus 4.8",
  "opus-46": "Claude Opus 4.6",
  "sonnet-46": "Claude Sonnet 4.6",
  "gpt-53-codex": "GPT-5.3-codex",
};

/** A project's `model` property as people read it (the raw key if it has no display name); undefined when unset. */
export const modelLabel = (value: unknown): string | undefined =>
  typeof value === "string" && value ? (MODEL_LABELS[value] ?? value) : undefined;
